/**
 * The OWASP Top 10 vocabulary for the UI.
 *
 * Mirrors backend/utils/owasp.js and the CHECK constraints on
 * findings.owasp_category and vulnerability_templates.owasp_category. Codes are
 * edition-qualified ('A01:2021') so a future edition is a new value set rather
 * than a silent reinterpretation of rows already written.
 *
 * "Not Set" is the empty string, not a code. The backend reads an empty string
 * as "clear this" and an absent key as "leave it alone", which is what makes a
 * mistaken classification correctable -- a plain COALESCE would have made the
 * field unclearable through the only edit path in the product.
 */

export const OWASP_TOP10 = [
  { code: 'A01:2021', name: 'Broken Access Control' },
  { code: 'A02:2021', name: 'Cryptographic Failures' },
  { code: 'A03:2021', name: 'Injection' },
  { code: 'A04:2021', name: 'Insecure Design' },
  { code: 'A05:2021', name: 'Security Misconfiguration' },
  { code: 'A06:2021', name: 'Vulnerable and Outdated Components' },
  { code: 'A07:2021', name: 'Identification and Authentication Failures' },
  { code: 'A08:2021', name: 'Software and Data Integrity Failures' },
  { code: 'A09:2021', name: 'Security Logging and Monitoring Failures' },
  { code: 'A10:2021', name: 'Server-Side Request Forgery (SSRF)' },
];

/** Options for a Select, with Not Set first and never pre-selected to a code. */
export const OWASP_OPTIONS = [
  { value: '', label: 'Not Set' },
  ...OWASP_TOP10.map(o => ({ value: o.code, label: `${o.code} — ${o.name}` })),
];

export function owaspLabel(code) {
  const hit = OWASP_TOP10.find(o => o.code === code);
  return hit ? `${hit.code} — ${hit.name}` : '';
}

export default OWASP_TOP10;
